import React, { useEffect, useState, useRef } from "react";
import { Form, Button, notification } from "antd";
import { Grid, TextField } from "@mui/material";
import { Auth } from "../services/authService"; // Ajusta la ruta según tu estructura
import LogoImg from "../assets/Logo2.jpg";
import Modal from "../components/Modal";
import { COLORS } from "../config/theme";
import { useNavigate } from "react-router-dom";
import UploadFile from "../components/UploadFile";
import { creatSignUpFiles } from "../services/uploadFile.service";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from "@mui/material";
import CircleIcon from "@mui/icons-material/Circle"; // Importa el icono de un círculo
import "./SignUp.css";
import { STRINGS } from "../dictionaries/ESP.dictionary";
import GooglePlacesInput from "../components/GooglePlacesInput";

const SignUp = () => {
  const authController = new Auth();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    nombre: null,
    mail: null,
    id_tipo_us: "1",
    ext_cuit: null,
    ext_razon_social: null,
    ext_telefono: null,
    ext_profesion: null,
    ext_matricula: null,
    ext_domicilio: null,
    ext_localidad: null,
    ext_provincia: null,
    password: null,
  });
  const [fileSelectedext, setFileSelected] = useState([]);
  const [repeatPassword, setRepeatPassword] = useState(""); // Estado para repetir la contraseña
  const [passwordVisible, setPasswordVisible] = React.useState(false);
  const [isVisibleModalPassword, setIsVisibleModalPassword] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);
  const [loading, setLoading] = useState(false);
  const passwordRef = useRef(null);

  const addFiles = async () => {
    try {
      if (fileSelectedext?.length > 0) {
        const uploadResults = await Promise.all(
          fileSelectedext.map(async (file) => {
            const result = await creatSignUpFiles(file.file);

            if (result?.status === 200) {
              return result;
            }
            return null;
          })
        );
        if (uploadResults?.length > 0) {
          return uploadResults;
        }
        return [];
      } else {
        return [];
      }
    } catch (error) {
      console.log("Failed to add selection", error);
    }
  };

  const changeForm = (e) => {
    const { name, value } = e.target;
    setInputs((prevInputs) => ({
      ...prevInputs,
      [name]: value,
    }));
  };

  const handleSignUp = async () => {
    if (inputs.password !== repeatPassword) {
      notification.error({
        message: "Las contraseñas no coinciden",
      });
      passwordRef.current.focus(); // Coloca el foco en el input de password
      return;
    }
    setLoading(true);
    const uploadedFiles = await addFiles();
    inputs.files = uploadedFiles;

    try {
      const response = await authController.register(inputs);
      console.log("response del registro", response);
      notification.success({ message: "Registro exitoso" });
      goToLogin();
    } catch (error) {
      console.log("error de registración", error);
      notification.error({
        message: error?.message || "No se pudo registrar el usuario",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCompleteSelection = async (selection) => {
    console.log("Archivo seleccionado", selection);
  };

  const goToLogin = () => {
    navigate("/");
  };

  const verifyPassword = () => {
    if (inputs.password !== repeatPassword) {
      notification.error({
        message: "Las contraseñas no coinciden",
      });
      passwordRef.current.focus();
    }
  };

  const handlePlaceSelected = (place) => {
    // setAddress(place);
    console.log("Lugar seleccionado:", place); // Maneja el lugar seleccionado
    setInputs((prevInputs) => ({
      ...prevInputs,
      ext_domicilio: `${place.calle} ${place.numero}`,
      ext_localidad: `${place.localidad}`,
      ext_provincia: `${place.provincia}`,
    }));
  };

  return (
    <div className="sign-in-Page">
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div
          className="registerForm"
          style={{ backgroundColor: COLORS.MAIN, color: COLORS.FONT }}
        >
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between", // Distribuir elementos a los extremos
              alignItems: "center", // Centrar elementos verticalmente
              padding: "1rem 2rem", // Espaciado
            }}
          >
            {/* Logo alineado a la izquierda */}
            <div style={{ flex: 1 }}>
              <img
                src={LogoImg}
                alt="Logo"
                style={{
                  height: "60px",
                  marginLeft: "15px",
                  objectFit: "contain",
                }}
              />
            </div>

            {/* Título centrado */}
            <div style={{ flex: 2, textAlign: "center" }}>
              <h4>{STRINGS.TITLE_PLATFORM}</h4>
            </div>

            {/* Espaciador vacío para simetría */}
            <div style={{ flex: 1 }}></div>
          </div>

          <Form className="containerRegisterControls" onFinish={handleSignUp}>
            <Grid container spacing={2}>
              {/* NOMBRE */}
              <Grid item xs={12} sm={5}>
                <TextField
                  fullWidth
                  name="nombre"
                  label="Nombre"
                  size="small"
                  required
                  variant="outlined"
                  value={inputs.nombre}
                  onChange={changeForm}
                />
              </Grid>
              {/* TIPO DE USUARIO */}
              <Grid item xs={12} sm={4}>
                <TextField
                  label="Tipo de Usuario"
                  name="id_tipo_us"
                  value={inputs.id_tipo_us}
                  onChange={changeForm}
                  size="small"
                  fullWidth
                  select
                  SelectProps={{ native: true }}
                  InputLabelProps={{ shrink: true }}
                >
                  <option value="1">Profesional</option>
                  <option value="2">Particular</option>
                </TextField>
              </Grid>
              {/* CUIT */}
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  name="ext_cuit"
                  size="small"
                  label="CUIT/CUIL"
                  required
                  variant="outlined"
                  value={inputs.ext_cuit}
                  onChange={changeForm}
                />
              </Grid>

              {/* EMAIL */}
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  name="mail"
                  label="Email"
                  required
                  variant="outlined"
                  size="small"
                  type="email"
                  value={inputs.mail}
                  onChange={changeForm}
                />
              </Grid>
              {/* TELÉFONO */}
              <Grid item xs={12} sm={4}>
                <TextField
                  fullWidth
                  name="ext_telefono"
                  required
                  size="small"
                  label="Teléfono"
                  variant="outlined"
                  value={inputs.ext_telefono}
                  onChange={changeForm}
                />
              </Grid>
              <Grid item xs={2} />

              {inputs.id_tipo_us === "1" && (
                <>
                  {/* RAZÓN SOCIAL */}
                  <Grid item xs={12} sm={5}>
                    <TextField
                      fullWidth
                      name="ext_razon_social"
                      size="small"
                      label="Razón Social"
                      variant="outlined"
                      value={inputs.ext_razon_social}
                      onChange={changeForm}
                    />
                  </Grid>
                  {/* PROFESI+ON */}
                  <Grid item xs={12} sm={4}>
                    <TextField
                      fullWidth
                      name="ext_profesion"
                      required
                      size="small"
                      label="Profesión"
                      variant="outlined"
                      value={inputs.ext_profesion}
                      onChange={changeForm}
                    />
                  </Grid>
                  {/* MATRÍCULA */}
                  <Grid item xs={12} sm={3}>
                    <TextField
                      fullWidth
                      name="ext_matricula"
                      required
                      size="small"
                      label="Matrícula"
                      variant="outlined"
                      value={inputs.ext_matricula}
                      onChange={changeForm}
                    />
                  </Grid>
                </>
              )}
              {inputs.id_tipo_us === "2" && (
                <>
                  <Grid item xs={12} sm={4}></Grid>
                  <Grid item xs={12} sm={4}></Grid>
                </>
              )}

              {/* DOMICILIO */}
              <Grid item xs={12} sm={6}>
                <GooglePlacesInput onPlaceSelected={handlePlaceSelected} />
                {/* <TextField
                  label="Domicilio"
                  size="small"
                  name="ext_domicilio"
                  value={inputValue}
                  onChange={(e) => handleAddressChange(e.target.value, "ext_domicilio")}
                  inputRef={inputRef}
                  fullWidth
                /> */}
              </Grid>
              {/* LOCALIDAD */}
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  name="ext_localidad"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Localidad"
                  variant="outlined"
                  value={inputs.ext_localidad}
                  disabled
                />
              </Grid>
              {/* PROVINCIA */}
              <Grid item xs={12} sm={3}>
                <TextField
                  fullWidth
                  name="ext_provincia"
                  size="small"
                  InputLabelProps={{
                    shrink: true,
                  }}
                  label="Provincia"
                  variant="outlined"
                  value={inputs.ext_provincia}
                  disabled
                />
              </Grid>

              {/* PASSWORD */}
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="password"
                  inputRef={passwordRef}
                  required
                  label="Password"
                  size="small"
                  variant="outlined"
                  type={passwordVisible ? "text" : "password"}
                  onChange={changeForm}
                />
              </Grid>
              {/* REPETIR PASSWORD */}
              <Grid item xs={4}>
                <TextField
                  fullWidth
                  name="repeatPassword"
                  label="Repetir Password"
                  size="small"
                  variant="outlined"
                  type={passwordVisible ? "text" : "password"}
                  value={repeatPassword}
                  onChange={(e) => setRepeatPassword(e.target.value)} // Actualiza el estado repeatPassword
                  onBlur={verifyPassword} // Verifica al salir del campo
                />
              </Grid>
              <Grid item xs={4}></Grid>
              <Grid item xs={12}>
                <Typography variant="h5" gutterBottom>
                  Por favor, adjunta la siguiente documentación:
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4}>
                    <List>
                      <ListItem>
                        <ListItemIcon>
                          <CircleIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="DNI Frente" />
                      </ListItem>
                    </List>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <List>
                      <ListItem>
                        <ListItemIcon>
                          <CircleIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary="DNI Dorso" />
                      </ListItem>
                    </List>
                  </Grid>
                  {inputs.id_tipo_us === "1" && (
                    <Grid item xs={12} sm={4}>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <CircleIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Matrícula" />
                        </ListItem>
                      </List>
                    </Grid>
                  )}
                  {inputs.id_tipo_us === "2" && (
                    <Grid item xs={12} sm={4}>
                      <List>
                        <ListItem>
                          <ListItemIcon>
                            <CircleIcon fontSize="small" />
                          </ListItemIcon>
                          <ListItemText primary="Foto de algún servicio que acredite titularidad (ej. boleta de luz)" />
                        </ListItem>
                      </List>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <UploadFile
                  setFileSelected={setFileSelected}
                  fileSelectedext={fileSelectedext}
                  onCompleteFileSelection={handleCompleteSelection}
                />
              </Grid>

              {/* BOTÓN REGISTRAR */}
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <div
                  className="containerLoginButton"
                  style={{ paddingTop: "1rem" }}
                >
                  <Button
                    className="login-form__button"
                    loading={loading}
                    htmlType="submit"
                  >
                    {STRINGS.REGISTER}
                  </Button>
                </div>
              </Grid>
              <Grid item xs={4}></Grid>

              {/* LINK INGRESAR */}
              <Grid item xs={4}></Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    paddingTop: "15px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  onClick={goToLogin}
                >
                  <span className="buttonRecuperarPass">{STRINGS.ENTER}</span>
                </div>
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </Form>
        </div>

        <Modal
          title={modalTitle}
          open={isVisibleModalPassword}
          setIsVisible={setIsVisibleModalPassword}
        >
          {modalContent}
        </Modal>
      </div>
    </div>
  );
};

export default SignUp;
